import { useEffect, useState } from 'react';
import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { analyticsService } from '~/initializeStore';
import { COOKIE_CONSENT_KEY } from '~/services/WebAnalyticsService';

const { Text, Link } = Typography;

export const COOKIE_CONSENT_RESET_EVENT = 'cookieconsent:reset';

const CookieConsentBanner = () => {
  const { t } = useTranslation('common');

  const [visible, setVisible] = useState<boolean>(
    () => localStorage.getItem(COOKIE_CONSENT_KEY) === null
  );

  useEffect(() => {
    const handleReset = () => setVisible(true);
    window.addEventListener(COOKIE_CONSENT_RESET_EVENT, handleReset);

    return () => window.removeEventListener(COOKIE_CONSENT_RESET_EVENT, handleReset);
  }, []);

  const handleAccept = () => {
    analyticsService.enable();
    setVisible(false);
  };

  const handleReject = () => {
    analyticsService.disable();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: '#fff',
        borderTop: '1px solid #e8e8e8',
        boxShadow: '0 -2px 8px rgba(0,0,0,0.08)',
        padding: '16px 24px',
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        flexWrap: 'wrap',
      }}
    >
      <div style={{ flex: 1, minWidth: 260 }}>
        <Text strong style={{ display: 'block', marginBottom: 4 }}>
          {t('cookieConsent.title')}
        </Text>
        <Text type="secondary" style={{ fontSize: 13 }}>
          {t('cookieConsent.description')}{' '}
          <Link href="/privacy-policy" target="_blank" rel="noopener noreferrer">
            {t('cookieConsent.learnMore')}
          </Link>
        </Text>
      </div>
      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        <Button onClick={handleReject}>{t('cookieConsent.reject')}</Button>
        <Button onClick={handleAccept}>{t('cookieConsent.accept')}</Button>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
